(function () {
  console.log('FPD: script loaded');

  // -----------------------
  // Helpers de dinero
  // -----------------------
  function getCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return Shopify.currency.active;
      }
    } catch (e) {}
    var html = document.documentElement;
    var dataCur = html && html.getAttribute('data-currency');
    if (dataCur) return dataCur;
    return 'EUR';
  }

  var CURRENCY = getCurrency();

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return amount.toLocaleString(undefined, {
        style: 'currency',
        currency: CURRENCY,
      });
    } catch (e) {
      return amount.toFixed(2) + ' ' + CURRENCY;
    }
  }

  // -----------------------
  // INIT GLOBAL
  // -----------------------
  function initAll(origin) {
    var sections = document.querySelectorAll('[data-fpd-section]');
    console.log('FPD: initAll from', origin, 'sections found:', sections.length);
    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll('DOMContentLoaded');
  });

  window.addEventListener('load', function () {
    initAll('window.load');
  });

  // disparo extra inmediato por si el DOM ya está listo
  setTimeout(function () {
    initAll('setTimeout-0');
  }, 0);

  // Eventos de Shopify en el editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-fpd-section]');
    console.log('FPD: shopify:section:load', section);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:select', function (e) {
    var section = e.target.querySelector('[data-fpd-section]');
    console.log('FPD: shopify:section:select', section);
    if (section) initSection(section);
  });

  // -----------------------
  // INIT DE UNA SECCIÓN
  // -----------------------
  function initSection(section) {
    if (!section) return;
    var id = section.getAttribute('id') || '(sin id)';
    console.log('FPD: initSection for', id);

    var productJsonEl = section.querySelector('[data-fpd-product-json]');
    if (!productJsonEl) {
      console.warn('FPD: no product json en sección', id);
      return;
    }

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      console.error('FPD: error parseando JSON de producto', e);
      return;
    }

    if (!product || !product.variants || !product.variants.length) {
      console.warn('FPD: producto sin variantes en sección', id);
      return;
    }

    var variantInput = section.querySelector('[data-fpd-variant-id]');
    var currentVariant = product.variants[0];

    if (variantInput && variantInput.value) {
      var found = product.variants.find(function (v) {
        return String(v.id) === String(variantInput.value);
      });
      if (found) currentVariant = found;
    }

    initGallery(section);
    initVariantSelectors(section, product, function (variant) {
      currentVariant = variant;
      updateVariantUI(section, currentVariant);
    });

    updateVariantUI(section, currentVariant);
  }

  // -----------------------
  // GALERÍA
  // -----------------------
  function initGallery(section) {
    var slides = Array.from(section.querySelectorAll('[data-fpd-slide]'));
    if (!slides.length) {
      console.log('FPD: no slides en galería');
      return;
    }

    var thumbs = Array.from(section.querySelectorAll('[data-fpd-thumb]'));
    var prevBtn = section.querySelector('[data-fpd-gallery-prev]');
    var nextBtn = section.querySelector('[data-fpd-gallery-next]');
    var thumbsWrapper = section.querySelector('[data-fpd-thumbs]');
    var thumbsPrev = section.querySelector('[data-fpd-thumbs-prev]');
    var thumbsNext = section.querySelector('[data-fpd-thumbs-next]');
    var mainWrapper = section.querySelector('[data-fpd-gallery-main]');

    var currentIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (currentIndex < 0) currentIndex = 0;

    console.log(
      'FPD: initGallery - slides:',
      slides.length,
      'thumbs:',
      thumbs.length,
      'startIndex:',
      currentIndex
    );

    function setActive(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });

      thumbs.forEach(function (thumb) {
        var idx = parseInt(thumb.getAttribute('data-target-index'), 10);
        thumb.classList.toggle('is-active', idx === currentIndex);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        console.log('FPD: click prev');
        setActive(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        console.log('FPD: click next');
        setActive(currentIndex + 1);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-target-index'), 10);
        console.log('FPD: click thumb', idx);
        if (!isNaN(idx)) setActive(idx);
      });
    });

    // Swipe en mobile
    if (mainWrapper) {
      var startX = 0;
      var endX = 0;
      var threshold = 40;

      mainWrapper.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
        endX = startX;
      });

      mainWrapper.addEventListener('touchmove', function (e) {
        if (!e.touches || !e.touches.length) return;
        endX = e.touches[0].clientX;
      });

      mainWrapper.addEventListener('touchend', function () {
        var delta = endX - startX;
        if (Math.abs(delta) < threshold) return;
        console.log('FPD: swipe delta', delta);
        if (delta < 0) {
          setActive(currentIndex + 1);
        } else {
          setActive(currentIndex - 1);
        }
      });
    }
  }

  // -----------------------
  // VARIANTES
  // -----------------------
  function initVariantSelectors(section, product, onVariantChange) {
    var container = section.querySelector('[data-fpd-variants]');
    if (!container) {
      console.log('FPD: no container de variantes');
      return;
    }

    var buttons = Array.from(section.querySelectorAll('[data-fpd-option-value]'));
    if (!buttons.length) {
      console.log('FPD: no botones de variante');
      return;
    }

    console.log('FPD: initVariantSelectors - botones:', buttons.length);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-option-position'), 10);
        var val = btn.getAttribute('data-option-value');
        console.log('FPD: click variante', pos, val);
        if (!pos || !val) return;

        var groupButtons = buttons.filter(function (b) {
          return parseInt(b.getAttribute('data-option-position'), 10) === pos;
        });
        groupButtons.forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });

        var label = section.querySelector(
          '[data-fpd-option-current="' + pos + '"]'
        );
        if (label) label.textContent = val;

        var selectedOptions = getSelectedOptions(section);
        console.log('FPD: selectedOptions', selectedOptions);

        var variant = findVariantByOptions(product, selectedOptions);
        if (!variant) {
          console.warn('FPD: no se encontró variante para', selectedOptions);
          return;
        }

        if (typeof onVariantChange === 'function') {
          onVariantChange(variant);
        }
      });
    });
  }

  function getSelectedOptions(section) {
    var result = [];
    var groups = Array.from(section.querySelectorAll('.fpd-variants__option'));
    groups.forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      var selected = group.querySelector('.fpd-variants__value.is-selected');
      if (pos && selected) {
        result[pos - 1] = selected.getAttribute('data-option-value');
      }
    });
    return result;
  }

  function findVariantByOptions(product, options) {
    if (!product || !product.variants) return null;
    return (
      product.variants.find(function (v) {
        if (!v.options || v.options.length !== options.length) return false;
        for (var i = 0; i < options.length; i++) {
          if (options[i] && v.options[i] !== options[i]) return false;
        }
        return true;
      }) || null
    );
  }

  // -----------------------
  // UPDATE UI VARIANTE
  // -----------------------
  function updateVariantUI(section, variant) {
    if (!variant) return;
    console.log('FPD: updateVariantUI', variant.id, variant.title);

    var variantInput = section.querySelector('[data-fpd-variant-id]');
    if (variantInput) {
      variantInput.value = variant.id;
    }

    var addBtn = section.querySelector('[data-fpd-add-to-cart]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
    }

    var priceEl = section.querySelector('[data-fpd-price]');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    var compareEl = section.querySelector('[data-fpd-compare-price]');
    var savingsEl = section.querySelector('[data-fpd-savings]');

    if (compareEl || savingsEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.classList.remove('is-hidden');
        }
        if (savingsEl) {
          var diff = variant.compare_at_price - variant.price;
          var pct = Math.round((diff * 100) / variant.compare_at_price);
          savingsEl.textContent = 'Ahorras ' + pct + '%';
          savingsEl.classList.remove('is-hidden');
        }
      } else {
        if (compareEl) {
          compareEl.textContent = '';
          compareEl.classList.add('is-hidden');
        }
        if (savingsEl) {
          savingsEl.textContent = '';
          savingsEl.classList.add('is-hidden');
        }
      }
    }

var pricePerCupEl = section.querySelector('[data-fpd-price-per-cup]');
if (pricePerCupEl) {
  // Clave que viene de Liquid (ej: "custom.numero_tazas")
  var cupsKey = pricePerCupEl.dataset.cupsMetafield || 'custom.cups';

  var cups = 0;

  if (variant.metafields && variant.metafields.custom) {
    var raw = null;

    // Soportamos formato "custom.numero_tazas" o "numero_tazas" a pelo
    if (cupsKey.indexOf('custom.') === 0) {
      var innerKey = cupsKey.split('.')[1]; // "numero_tazas"
      raw = variant.metafields.custom[innerKey];
    } else {
      raw = variant.metafields.custom[cupsKey];
    }

    if (raw != null) {
      cups = Number(raw && raw.value != null ? raw.value : raw);
    }

    // Fallback: si no se ha encontrado nada con cupsKey, intenta "cups"
    if (!cups && variant.metafields.custom.cups != null) {
      var mf2 = variant.metafields.custom.cups;
      cups = Number(mf2 && mf2.value != null ? mf2.value : mf2);
    }
  }

  if (cups > 0) {
    var per = Math.round(variant.price / cups);
    pricePerCupEl.textContent = formatMoney(per) + '/taza' ;
    pricePerCupEl.classList.remove('is-hidden');
  } else {
    // Si no hay dato, sí lo ocultamos
    pricePerCupEl.textContent = '';
    pricePerCupEl.classList.add('is-hidden');
  }
}


    // Label de variante vía bloques
    var labelContainer = section.querySelector('[data-fpd-variant-label]');
    var labelsScript = section.querySelector('[data-fpd-variant-labels]');
    if (labelContainer && labelsScript) {
      var labels = [];
      try {
        labels = JSON.parse(labelsScript.textContent);
      } catch (e) {
        labels = [];
      }
      if (Array.isArray(labels) && labels.length) {
        var found = labels.find(function (rule) {
          if (!rule || !rule.match || !rule.text) return false;
          var title = variant.title || '';
          return (
            title.toLowerCase().indexOf(String(rule.match).toLowerCase()) !== -1
          );
        });
        if (found) {
          labelContainer.textContent = found.text;
          labelContainer.style.backgroundColor = found.bg || '#111111';
          labelContainer.style.color = found.color || '#ffffff';
          labelContainer.classList.add('is-visible');
        } else {
          labelContainer.textContent = '';
          labelContainer.classList.remove('is-visible');
        }
      } else {
        labelContainer.textContent = '';
        labelContainer.classList.remove('is-visible');
      }
    }

    // Cambiar slide si la variante tiene featured_media
    if (variant.featured_media && variant.featured_media.id) {
      var targetId = String(variant.featured_media.id);
      var slides = Array.from(section.querySelectorAll('[data-fpd-slide]'));
      var thumbs = Array.from(section.querySelectorAll('[data-fpd-thumb]'));
      var index = slides.findIndex(function (s) {
        return String(s.getAttribute('data-media-id')) === targetId;
      });
      console.log('FPD: featured_media', targetId, 'slideIndex', index);
      if (index >= 0) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        thumbs.forEach(function (thumb) {
          var idx = parseInt(thumb.getAttribute('data-target-index'), 10);
          thumb.classList.toggle('is-active', idx === index);
        });
      }
    }
  }
})();
